"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameRegistryState = void 0;
const web3_js_1 = require("@solana/web3.js");
class NameRegistryState {
    constructor(obj) {
        this.parentName = new web3_js_1.PublicKey(obj.parentName);
        this.owner = new web3_js_1.PublicKey(obj.owner);
        this.class = new web3_js_1.PublicKey(obj.class);
        this.data = Buffer.from(obj.data);
    }
    static deserialize(buffer) {
        return new NameRegistryState({
            parentName: buffer.slice(0, 32),
            owner: buffer.slice(32, 64),
            class: buffer.slice(64, 96),
            data: buffer.slice(96, buffer.length),
        });
    }
    static async retrieve(connection, nameAccountKey) {
        const nameAccount = await connection.getAccountInfo(nameAccountKey, 'processed');
        if (!nameAccount) {
            throw new Error('Invalid name account provided');
        }
        const res = NameRegistryState.deserialize(nameAccount.data);
        return res;
    }
}
exports.NameRegistryState = NameRegistryState;
//# sourceMappingURL=state.js.map